
export default {
  name: 'OrderItemSpecs',
  props: {
    item: { type: Object, required: true }
  }
}
